// Nadpisy sekcí stránky výsledků hledání z API (searchApiModel.js), SK.
export default {
  cats: 'Kategórie',
  brands: 'Značky',
  posts: 'Články',
  pages: 'Stránky',
};
